import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import IntlMessages from 'util/IntlMessages';

const SidenavSuperuserContent = () => {
    return (
        <Fragment>
            <li className="menu no-arrow">
                <NavLink to="/app/agile-dashboard/default">
                    <i className="zmdi zmdi-check-square zmdi-hc-fw" />
                    <span className="nav-text"><IntlMessages id="sidebar.agile.dashboard" /></span>
                </NavLink>
            </li>
            <li className="menu no-arrow">
                <NavLink to="/app/organisation/default">
                    <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                    <span className="nav-text"><IntlMessages id="sidebar.organisations" /></span>
                </NavLink>
            </li>
            <li className="menu no-arrow">
                <NavLink to="/app/survey-group/default">
                    <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
                    <span className="nav-text"><IntlMessages id="sidebar.surveyGroup" /></span>
                </NavLink>
            </li>
        </Fragment>
    );
};

export default SidenavSuperuserContent;



// WEBPACK FOOTER //
// ./containers/SideNav/SidenavSuperuserContent.js